export const selectInput = {
    border: 'none',
    color: 'var(--Iris-80, #7879F1)',
    fontSize: "14px",
    fontWeight: "500 !important",
    fontFamily: "Inter",
    border: '1px solid #E5E5E5 !important',
    width: '117px',
    height: '38px',
    ".MuiOutlinedInput-notchedOutline": {
        border: " none !important"
    }
}

export const custom = {
    width: '192px',
    height: '52px',
    padding: '11px 10px',
    borderRadius: '5px',
    color: '#000',
    fontSize: '16px',
    textTransform: 'capitalize',
    fontWeight: '500',
    lineHeight: '24px',
    fontFamily: 'DM Sans',
    border: '1px solid #B5B7C0',
    background:'transparent'
}

export const save = {
    height: '52px',
    width: '192px',
    padding: '11px 20px',
    borderRadius: '5px',
    background: '#1D83F8',
    color: '#fff',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px', /* 18.2px */
    overflow: 'hidden',
    fontFamily: 'DM Sans',
    "&:hover": {
        background: '#1E5EFF'
    },
    marginLeft: '10px'
}
export const saveCourse = {
    height: '52px',
    width: 'fit-content',
    padding: '11px 20px',
    borderRadius: '16px',
    background: '#1D83F8',
    color: '#fff',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px', /* 18.2px */
    overflow: 'hidden',
    fontFamily: 'DM Sans',
    "&:hover": {
        background: '#1E5EFF'
    },
    marginLeft: '10px'
}
export const customradius = {
    width:'120px',
    height: '56px',
    padding: '11px 20px',
    borderRadius: '16px',
    background: '#fff',
    border:' 1px solid #E9EAF0',
    color: '#6E7485',
    fontSize: '18px',
    textTransform: 'capitalize',
    fontFamily:'Figtree',
    fontWeight: '500',
    lineHeight: '130%', /* 18.2px */
    overflow: 'hidden',
    "&:hover": {
        background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), rgba(255, 255, 255, 0.70)',
    }
}

export const saveradius = {
    height: '42px',
    padding: '11px 20px',
    borderRadius: '0px',
    background: 'linear-gradient(0deg, #000 0%, #000 100%), rgba(255, 255, 255, 0.70)',
    color: '#fff',
    textTransform: 'capitalize',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '130%', /* 18.2px */
    overflow: 'hidden',
    "&:hover": {
        background: 'linear-gradient(0deg, #000 0%, #000 100%), rgba(255, 255, 255, 0.70)',
    }
}
export const googlemap = {
    height: '42px',
    padding: '9px 17px',
    borderRadius: '6px',
    background: 'linear-gradient(0deg, #000 0%, #000 100%), rgba(255, 255, 255, 0.70)',
    color: '#fff',
    textTransform: 'capitalize',
    fontFamily: 'Work Sans',
    fontSize: '14px',
    fontWeight: '500',
    position: 'absolute',
    right: '10px',
    bottom: '8px',
    lineHeight: '130%', /* 18.2px */
    overflow: 'hidden',
    "&:hover": {
        background: 'linear-gradient(0deg, #000 0%, #000 100%), rgba(255, 255, 255, 0.70)',
    }
}
export const formselect = {
    width: '100%',
    color: '#8D8D8D',
    fontFamily: 'Poppins',
    lineHeight: '20px',
    fontSize: '14px',
    outline: 'none !important',
    borderRadius: '4px',
    border: '1px solid var(--Gray-100, #E9EAF0) !important',
    ".MuiSelect-select": {
        padding: '12px 18px !important'
    },
    ".MuiOutlinedInput-notchedOutline": {
        border: "none !important"
    },
    ".MuiInputBase-input": {
        padding: '12px 18px !important'
    }
}
export const delet = {
    height: '42px',
    padding: '11px 20px',
    borderRadius: '6px',
    background: '#F0142F',
    color: '#fff',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px', /* 18.2px */
    overflow: 'hidden',
    fontFamily: 'DM Sans',
    "&:hover": {
        background: '#F0142F'
    },
    marginLeft: '10px'
}
export const cancle = {
    height: '42px',
    padding: '11px 20px',
    borderRadius: '6px',
    background: '#FFF',
    color: '#000',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px', /* 18.2px */
    overflow: 'hidden',
    fontFamily: 'DM Sans',
    "&:hover": {
        background: '#1E5EFF',
        color: '#fff'
    },
    marginLeft: '10px'
}
export const accept = {
    height: '42px',
    padding: '11px 20px',
    borderRadius: '6px',
    background: '#0F9A1D',
    color: '#FFFFFF',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px', /* 18.2px */
    overflow: 'hidden',
    fontFamily: 'DM Sans',
    "&:hover": {
        background: '#0F9A1F'
    },
    marginLeft: '10px'
}
export const apply = {
    width: '100%',
    height: '42px',
    padding: '11px 0px 11px 0px',
    borderRadius: '6px',
    background: '#5570F1',
    color: '#FFFFFF',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px', /* 18.2px */
    overflow: 'hidden',
    fontFamily: 'DM Sans',
    "&:hover": {
        background: '#5570F1'
    },
    marginTop:'30px'
}
export const Apply = {
    width: '150px',
    height: '36px',
    padding: '17px 16px 17px 16px',
    gap: '10px',
    borderRadius: '12px',

    background: '#5570F1',
    color: '#FFFFFF',
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '24px', /* 18.2px */
    overflow: 'hidden',
    fontFamily:'DM Sans',
    "&:hover": {
        background:'#5570F1'
    },
    marginTop:'30px'
}
export const Reset = {
    width: '150px',
    height: '36px',
    padding: '17px 16px 17px 16px',
    gap: '10px',
    borderRadius: '12px',
    background: '#DBDADE',
    color: '#000',
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '24px', /* 18.2px */
    overflow: 'hidden',
    fontFamily:'DM Sans',
    "&:hover": {
        background:'#5570F1',
        color: '#fff'
    },
    marginTop:'30px',
    marginRight:'10px',
    marginTop: '30px'
}